import { ParentSize } from '@visx/responsive';
import usePlayer from "./usePlayer.js";
import Controls from "../shared/Controls.js";
import S from './MpegTsPlayer.css';
import PTZDragTool from "../shared/PTZDragTool.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CLIENT = 'MpegTsPlayer';
export default function MpegTsPlayer(props) {
  const {
    getAuthHeader,
    height: pHeight,
    poster,
    url,
    width: pWidth,
    context
  } = props;
  const {
    controls: {
      fullscreenSupported,
      isFullscreen,
      isPoppedOut,
      loading,
      onFullscreen,
      onMouseMove,
      onPictureInPicture,
      onPlayPause,
      pictureInPictureSupported,
      playing,
      ref: controlsRef,
      visible
    },
    ref,
    containerRef,
    error
  } = usePlayer({
    url,
    getAuthHeader
  });
  return /*#__PURE__*/_jsx(ParentSize, {
    children: ({
      width,
      height
    }) => {
      return /*#__PURE__*/_jsxs("div", {
        ref: containerRef,
        onMouseMove: onMouseMove,
        className: S.videoContainer,
        style: {
          width: pWidth || width,
          height: pHeight || height
        },
        children: [/*#__PURE__*/_jsx(Controls, {
          isFullscreen: isFullscreen,
          isPoppedOut: isPoppedOut,
          domRef: controlsRef,
          fullscreenSupported: fullscreenSupported,
          isLoading: loading,
          isPlaying: playing,
          isVisible: visible,
          onFullscreen: onFullscreen,
          onPictureInPicture: onPictureInPicture,
          onPlayPause: onPlayPause,
          pictureInPictureSupported: pictureInPictureSupported,
          error: error,
          poster: poster,
          context: context,
          client: CLIENT
        }), playing && /*#__PURE__*/_jsx(PTZDragTool, {
          parentRef: containerRef,
          parentWidth: width,
          parentHeight: height,
          context: context
        }), /*#__PURE__*/_jsx("video", {
          tabIndex: 0,
          autoPlay: true,
          ref: ref
        })]
      });
    }
  });
}